import APIService from 'services/APIService'

const api = APIService()

export const listContracts = params =>
  api.get('/me/contracts', { params })

export const getSupplyChain = () =>
  api.get('/me/contracts/supply-chain')

export const createContract = payload =>
  api.post('/me/contracts', payload)

export const updateContract = (id, payload) =>
  api.patch(`/me/contracts/${id}`, payload)

export const deleteContract = id =>
  api.delete(`/me/contracts/${id}`)

export const presignContractDocument = (id, payload) =>
  api.post(`/me/contracts/${id}/documents/presign`, payload)

export const addContractDocument = (id, payload) =>
  api.post(`/me/contracts/${id}/documents`, payload)

export const downloadContractDocument = (id, docId) =>
  api.get(`/me/contracts/${id}/documents/${docId}/download`)

export const deleteContractDocument = (id, docId) =>
  api.delete(`/me/contracts/${id}/documents/${docId}`)
